import React from 'react';
import { Accordion } from 'react-bootstrap';
const AccordionCollapse = (props) => {
    const { classificationName, anchorClauses, comparatorClauses, activeClauseIds, setActiveClauseIds, } = props;
    const handleAnchorClick = (id) => {
        setActiveClauseIds(Object.assign(Object.assign({}, activeClauseIds), { anchorClause: id }));
    };
    const handleComparatorClick = (id) => {
        setActiveClauseIds(Object.assign(Object.assign({}, activeClauseIds), { comparatorClause: id }));
    };
    return (React.createElement(Accordion.Collapse, { eventKey: classificationName, style: { height: 'auto' } },
        React.createElement(React.Fragment, null,
            anchorClauses.length > 0 &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'icon-anchor' },
                        React.createElement("i", { className: 'fas fa-star' })),
                    React.createElement("div", { className: 'collapse-clauses' }, anchorClauses === null || anchorClauses === void 0 ? void 0 : anchorClauses.map((clause, index) => {
                        var _a, _b;
                        const isSelected = clause.id === activeClauseIds.anchorClause;
                        const pageNum = (_b = (_a = clause.regions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.pageNum;
                        return (React.createElement("div", { className: 'collapse-clauses-container', key: index, onClick: () => handleAnchorClick(clause.id) },
                            React.createElement("span", { className: `collapse-clause ${isSelected ? 'selected' : ''}` }, clause.descriptorTag.displayName),
                            pageNum &&
                                React.createElement("span", { className: 'page-num' }, ` (p. ${pageNum})`)));
                    }))),
            comparatorClauses.length > 0 &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'icon-compare' },
                        React.createElement("i", { className: 'fas fa-file' })),
                    React.createElement("div", { className: 'collapse-clauses' }, comparatorClauses === null || comparatorClauses === void 0 ? void 0 : comparatorClauses.map((clause, index) => {
                        var _a, _b;
                        const isSelected = clause.id === activeClauseIds.comparatorClause;
                        const pageNum = (_b = (_a = clause.regions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.pageNum;
                        const diffCategory = (anchorClauses === null || anchorClauses === void 0 ? void 0 : anchorClauses.length) > 0 &&
                            anchorClauses[0].categoryTag.id !== clause.categoryTag.id;
                        return (React.createElement("div", { className: 'collapse-clauses-container', key: index, onClick: () => handleComparatorClick(clause.id) },
                            diffCategory &&
                                React.createElement("div", { className: `clause-diff-category ${isSelected ? 'selected' : ''}` },
                                    clause.categoryTag.displayName,
                                    "\u00A0",
                                    React.createElement("span", { className: 'diff-icon' },
                                        React.createElement("i", { className: 'fas fa-exchange-alt' }))),
                            React.createElement("span", { className: `collapse-clause ${isSelected ? 'selected' : ''}` }, clause.descriptorTag.displayName),
                            pageNum &&
                                React.createElement("span", { className: 'page-num' }, ` (p. ${pageNum})`),
                            clause.similarityMatch &&
                                React.createElement("span", { className: 'similarity-marker', title: 'Aligned by semantic similarity to the anchor clause in this row' },
                                    React.createElement("i", { className: 'fas fa-sparkles' }),
                                    ` ${clause.similarityMatch.score.toFixed(2)}`)));
                    }))))));
};
export default AccordionCollapse;
